import { render } from "./Nomina.vue?vue&type=template&id=1411eb0a&scoped=true"
import script from "./Nomina.vue?vue&type=script&lang=js"
export * from "./Nomina.vue?vue&type=script&lang=js"

import "./Nomina.vue?vue&type=style&index=0&id=1411eb0a&scoped=true&lang=css"

import exportComponent from "/var/www/html/genesis-git/vue-genesis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1411eb0a"]])

export default __exports__